/** @jsx jsx */
/** @jsxfrag */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
export var AppRecommendations = function AppRecommendations(_ref) {
  var children = _ref.children;
  return jsx(React.Fragment, null, children);
};